module.exports = "<main role=\"main\" class=\"container-fluid\">\n  <router-outlet></router-outlet>\n</main>\n"